import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=392a6ae6"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392a6ae6')) {
      api.createRecord('392a6ae6', component.options)
    } else {
      api.reload('392a6ae6', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=392a6ae6", function () {
      api.rerender('392a6ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/Statistics.vue"
export default component.exports